import { NgModule,LOCALE_ID  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CifradoPipe, DecryptPipe } from './cifrado.pipe';
import { ImagenPipe } from './imagen.pipe';
import { niceDateFormatPipe } from './niceDateFormat.pipe';
import { DatePipe } from '@angular/common';
import { FormatFileSizePipe } from './FormatFileSizePipe .pipe';
import { MonthNamePipe } from './nameMonth.pipe';
import { ImagenCompanyPipe } from './imagenCompany.pipe';
import { XmlPipe } from './xml.pipe';


@NgModule({
  declarations: [
    DecryptPipe,
    CifradoPipe,
    ImagenPipe,
    niceDateFormatPipe,
    FormatFileSizePipe,
    MonthNamePipe,
    ImagenCompanyPipe,
    XmlPipe
  ],
  imports: [
    CommonModule
  ],
  exports:[
    DecryptPipe,
    CifradoPipe,
    ImagenPipe,
    niceDateFormatPipe,
    FormatFileSizePipe,
    MonthNamePipe,
    ImagenCompanyPipe,
    XmlPipe
  ],
  providers: [

]
})
export class PipesModule { }
